module.exports = __webpack_public_path__ + "media/flags/021-mexico-e31dbd6b.svg";